import React, { Component } from "react";
import { getGoalData } from "../../api";
import goalImg from "../../../images/goal.png";
import { Button } from "react-bootstrap";
import SetGoalModal from "../modals/set-goal-modal/set-goal-modal";
import ReactApexChart from "react-apexcharts";
import caretImg from "../../../images/caret.png";
import SelectDropDown from "./drop-down";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

class SetGoal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goalData: {
                submitting_apps: null,
                approved_apps: null,
                monthly_volume: null,
            },
            goalProgress: null,
            setGoalModalShow: false,
            //chart
            series: [67, 83, 50],
            options: {
                chart: {
                    height: 170,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 0,
                            size: "37%",
                        },
                        track: {
                            strokeWidth: "50%",
                            margin: 0,
                        },
                        dataLabels: {
                            total: {
                                show: true,
                                label: "",
                                formatter: function (w) {
                                    return "";
                                },
                            },
                        },
                    },
                },
                colors: ["#9080F1", "#74C672", "#2B7FDB"],
                labels: ["Monthly Volume", "Approved", "Submitting"],
                stroke: {
                    lineCap: "round",
                    curve: "smooth",
                },
            },
            dropUserText: "",
            agentGoalData: null,
            orgGoalData: null,
        };
    }

    componentDidMount() {
        getGoalData()
            .then((res) => {
                this.setState({
                    goalProgress: res,
                    series: [
                        res.monthlyVolume.perc,
                        res.approvedApps.perc,
                        res.submittedApps.perc,
                    ],
                    agentGoalData: res.agentGoalData,
                    orgGoalData: res.orgGoalData,
                });
            })
            .catch((err) => {});
    }

    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => ({
            goalData: {
                ...prevState.goalData,
                [name]: value,
            },
        }));
    };
    openSetGoalModal = () => {
        this.setState({
            setGoalModalShow: true,
        });
    };

    closeSetGoalModal = () => {
        this.setState({ setGoalModalShow: false });
        getGoalData()
            .then((res) => {
                this.setState({
                    goalProgress: res,
                });
            })
            .catch((err) => {});
    };

    getUpdatedUser = () => {
        this.componentDidMount();
    };

    handelUserChange = (e) => {
        let value = e.value;
        let params = {
            user: value,
        };
        if (value.split("-")[0] === "org") {
            this.setState({
                dropUserText: "Org",
            });
        } else {
            this.setState({
                dropUserText: "User",
            });
        }
        getGoalData(params)
            .then((res) => {
                if (
                    (res.orgGoalData.approved_apps == null &&
                        res.orgGoalData.approved_apps == null &&
                        res.orgGoalData.approved_apps == null) ||
                    (res.agentGoalData.approved_apps == null &&
                        res.agentGoalData.approved_apps == null &&
                        res.agentGoalData.approved_apps == null)
                ) {
                    MySwal.fire({
                        title: <p>This user does not have any goal data!</p>,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: false,
                        customClass: "margin-top-sweetalert",
                        didOpen: (toast) => {
                            toast.addEventListener(
                                "mouseenter",
                                Swal.stopTimer,
                            );
                            toast.addEventListener(
                                "mouseleave",
                                Swal.resumeTimer,
                            );
                        },
                    });
                }
                this.setState({
                    goalProgress: res,
                    series: [
                        res.monthlyVolume.perc,
                        res.approvedApps.perc,
                        res.submittedApps.perc,
                    ],
                });
            })
            .catch((err) => {});
    };

    render() {
        const { goalProgress } = this.state;
        return (
            <div className="app">
                <div className="shadow-card">
                    <div className="d-flex lr-padding5">
                        <img style={{ width: "auto" }} src={goalImg} />
                        <h4>Monthly Goal</h4>
                        <Button
                            className="set-goal"
                            onClick={this.openSetGoalModal}
                        >
                            Set Goal
                        </Button>
                        {this.props.user.organization_id > 1 &&
                        this.props.user.role === "admin" ? null : (
                            <div className="d-flex align-items-center analytics-filtering goal-dropdown">
                                <span>{this.state.dropUserText}</span>
                                <SelectDropDown
                                    options={this.props.dropDownUsers}
                                    name="periodoptn"
                                    placeholder="Choose To Filter"
                                    value=""
                                    handleChange={(evt) =>
                                        this.handelUserChange(evt)
                                    }
                                />
                            </div>
                        )}
                    </div>
                    <hr />
                    <div className="lr-padding5">
                        <div className="row m-0">
                            {goalProgress != null && (
                                <div className="col col-xs-8 goal-chart-col">
                                    <div className="d-flex dailygoal-detail1">
                                        <span className="dot dailygoal-detail1-dot"></span>
                                        <p className="goal-percent">
                                            {goalProgress.submittedApps.perc}%
                                        </p>
                                        <p className="status-text">
                                            Submitting apps
                                        </p>
                                        <p className="counting-goal">
                                            {
                                                goalProgress.submittedApps
                                                    .achieved
                                            }{" "}
                                            /{" "}
                                            {goalProgress.submittedApps
                                                .target == null
                                                ? 0
                                                : goalProgress.submittedApps
                                                      .target}{" "}
                                        </p>
                                    </div>

                                    <div className="d-flex dailygoal-detail2">
                                        <span className="dot dailygoal-detail2-dot"></span>
                                        <p className="goal-percent">
                                            {goalProgress.approvedApps.perc}%
                                        </p>
                                        <p className="status-text">
                                            Approved apps
                                        </p>
                                        <p className="counting-goal">
                                            {goalProgress.approvedApps.achieved}{" "}
                                            /{" "}
                                            {goalProgress.approvedApps.target ==
                                            null
                                                ? 0
                                                : goalProgress.approvedApps
                                                      .target}{" "}
                                        </p>
                                    </div>
                                    <div className="d-flex dailygoal-detail3">
                                        <span className="dot dailygoal-detail3-dot"></span>
                                        <p className="goal-percent">
                                            {goalProgress.monthlyVolume.perc}%
                                        </p>
                                        <p className="status-text">
                                            Monthly processing volume
                                        </p>
                                    </div>
                                </div>
                            )}
                            {goalProgress != null && (
                                <div className="col col-xs-4 text-center text-sm-right goal-pie-chart-col">
                                    <div id="goal-chart">
                                        <ReactApexChart
                                            options={this.state.options}
                                            series={this.state.series}
                                            type="radialBar"
                                            height={170}
                                            key={123}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {this.state.setGoalModalShow && (
                    <SetGoalModal
                        show={this.state.setGoalModalShow}
                        closeModal={this.closeSetGoalModal}
                        user={this.props.user}
                        getUpdatedUser={this.getUpdatedUser}
                        agentGoalData={this.state.agentGoalData}
                        orgGoalData={this.state.orgGoalData}
                    />
                )}
            </div>
        );
    }
}

export default SetGoal;
